module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2022/polkolonie/thumbs/5-2d99d62679d314d3da7706b5ae573498.webp";